import _Object$assign from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/assign";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import RevealFate from "@/components/revealFate/revealFate.vue";
import { sendMapEvent } from "@/utils/analytics";
import getHoroscopeFates from "@/utils/getHoroscopeFates";
import localStorageHelper from "../localstorage/localstorage";
import FunctionTags from "@/components/functionTags/functionTags.vue";
import CreateNotification from "@/utils/notificationUtil.ts";
import GeneralUtilsHelper from "@/utils/generalUtils";
import EventBus from "@/utils/eventBus";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import { isIos } from "@/utils/lodash";
import { getLang } from "@/api/utils/apiHelper";
import HoroScopeNewClient from "@/api/horoScopeNew/index";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import HomeReadCraouser from "@/components/homeReadCraouser/homeReadCraouser.vue"; // import ZMClient from "@/api/faceZMC";

var Home =
/*#__PURE__*/
function (_Vue) {
  _inherits(Home, _Vue);

  // import ZMClient from "@/api/faceZMC";
  function Home() {
    var _this;

    _classCallCheck(this, Home);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Home).apply(this, arguments));
    _this.homeScrollTop = 0;
    _this.homeAgeVideoUrl = "";
    _this.showViedo = false;
    _this.slideIndex = 0;
    _this.swiperOption = {
      // some swiper options/callbacks
      // 所有的参数同 swiper 官方 api 参数
      // ...
      centeredSlides: false,
      slidesPerView: 1.15,
      loop: true,
      observer: true,
      initialSlide: _this.slideIndex,
      observeParents: false,
      on: {
        slideChangeTransitionStart: function slideChangeTransitionStart() {// if (vm.reviewSwiper) {
          //   vm.slideIndex = vm.reviewSwiper.realIndex;
          // }
        }
      }
    };
    return _this;
  }

  _createClass(Home, [{
    key: "goToPlamistry",
    value: function goToPlamistry() {
      // localStorageHelper.remove('is_enter_pamistry_today')
      var isEnterPlamistryToday = localStorageHelper.get("is_enter_pamistry_today");
      var nowDay = new Date().getDate();

      if (isEnterPlamistryToday === nowDay) {
        this.routerPush({
          name: "palmistryResult",
          params: {
            routerTransition: "forward",
            fromHome: true
          }
        });
      } else {
        this.palmistry().catch(function (err) {});
      }
    }
  }, {
    key: "clickItem",
    value: function clickItem(fn, params) {
      fn && params ? fn(params) : fn();
      this.updateCardClickTime();
    }
  }, {
    key: "clickMenu",
    value: function clickMenu() {
      this.routerPush({
        name: "setting",
        params: {
          routerTransition: "forward"
        }
      });
    }
  }, {
    key: "onResume",
    value: function onResume() {
      this.videoPlay();
    }
  }, {
    key: "clickMid",
    value: function clickMid() {}
  }, {
    key: "getReadList",
    value: function () {
      var _getReadList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result, resultData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return HoroScopeNewClient.fetchArticleList("newest", "new");

              case 2:
                result = _context.sent;

                if (result && result.status === 200 && result.data) {
                  resultData = JSON.parse(result.data);

                  if (resultData.data && resultData.data.item_list && resultData.data.item_list.length > 0) {
                    this.updateReadingList(resultData.data.item_list);
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getReadList() {
        return _getReadList.apply(this, arguments);
      }

      return getReadList;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      window.StatusBar.styleDefault();

      if (this.horoScope) {
        getHoroscopeFates.getFates(false);
      }

      setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                new CreateNotification().sendNotification();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), 10000);
      this.fetchPalmPrintData(false);
      this.fetchFaceRadingData(false);
      this.getVideoUrl(); // 如果需要显示购买成功弹窗

      this.showSucessToast();

      if (isIos()) {
        this.videoPlay();
        document.addEventListener("resume", this.onResume, false);
      }

      this.getReadList();
    }
  }, {
    key: "showSucessToast",
    value: function showSucessToast() {
      if (this.getTempResultByName("canShowSuccessToast")) {
        EventBus.$emit("vip-purchase-success-toast-show");
      }
    }
  }, {
    key: "getVideoUrl",
    value: function () {
      var _getVideoUrl = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var videoType, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                videoType = this.lunchConfig && this.lunchConfig.launch_vip_video_local_resource ? "local" : "online";
                _context3.next = 3;
                return GeneralUtilsHelper.getVideoFileUrl("home_age_shutter.mp4", videoType);

              case 3:
                result = _context3.sent;
                this.homeAgeVideoUrl = result;
                this.showViedo = true;
                this.storeFunctionListData();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getVideoUrl() {
        return _getVideoUrl.apply(this, arguments);
      }

      return getVideoUrl;
    }()
  }, {
    key: "storeFunctionListData",
    value: function storeFunctionListData() {
      var _this2 = this;

      var list = this.mainFunctionList;
      var result_list = [];

      if (list) {
        list.forEach(function (v) {
          if (_this2.mapList[v.function]) {
            result_list.push(_Object$assign(_this2.mapList[v.function], v));
          }
        });
      }

      this.updateFunctionList({
        name: "functionList",
        result: result_list
      });
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        document.querySelector(".home-content-view").scrollTop = _this3.homeScrollTop;
      });
    }
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      var videoEl = document.getElementById("AgingShutter");

      if (this.homeAgeVideoUrl && videoEl) {
        // videoEl.pause();
        videoEl.load();
        var promise = videoEl.play();

        if (promise !== undefined) {
          promise.catch(function (error) {// console.log("// Auto-play was prevented");
          }).then(function () {// console.log("Auto-play started");
          });
        }
      }
    }
  }, {
    key: "activated",
    value: function activated() {
      this.showSucessToast();
      this.setScrollTop();
      this.videoPlay();
    }
  }, {
    key: "deactivated",
    value: function deactivated() {
      this.homeScrollTop = document.querySelector(".home-content-view").scrollTop;
    }
  }, {
    key: "isShowVipPadding",
    get: function get() {
      return this.cardClickTime >= 2 && this.$route.path === "/home" && !GeneralUtilsHelper.isVip();
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "mapList",
    get: function get() {
      var _this4 = this;

      return {
        PesonalityFuture: {
          img: this.$remoteImg("icons/home/personalitynfuture.png"),
          text: this.$t("home_page.main_function_list.personality_future"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "person_future"
            });

            _this4.personalFutrue().catch(function (err) {});
          }
        },
        AgingShutter: {
          img: this.$remoteImg("icons/home/age_shutter_home_208.gif"),
          text: this.$t("home_page.main_function_list.aging_shutter"),
          video: {
            poster: this.$remoteImg("icons/home/home_age_shutter_index.png"),
            src: this.homeAgeVideoUrl,
            id: "AgingShutter"
          },
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "age"
            });

            _this4.resetResultByName("agingShutter"); // 重置缓存值


            _this4.ageingForecast().catch(function (err) {});
          }
        },
        BeautyContest: {
          img: this.$remoteImg("icons/home/beauty_contest.png"),
          text: this.$t("home_page.main_function_list.beauty_contest"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "beauty_race"
            });

            _this4.routerPush({
              name: "beautyContest",
              params: {
                routerTransition: "forward"
              }
            });
          }
        },
        FutureBaby: {
          img: this.$remoteImg("icons/home/future_baby@3x.png"),
          text: this.$t("home_page.main_function_list.future_baby"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "future_baby"
            });

            _this4.routerPush({
              name: "futureBaby",
              params: {
                routerTransition: "forward"
              }
            });
          }
        },
        EthnicityScanner: {
          img: this.$remoteImg("icons/home/ethnicity_scanner.png"),
          text: this.$t("home_page.main_function_list.ethnicity_scanner"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "ethnicity"
            });

            _this4.ethnicityScanner().catch(function (err) {});
          }
        },
        ZodiacMatch: {
          img: this.$remoteImg("icons/home/zodiac_match_home.png"),
          text: this.$t("home_page.main_function_list.zodiac_match"),
          clickFunction: function clickFunction(item) {
            sendMapEvent("uia_card_click", {
              key: "Zodiac_Match"
            });

            _this4.routerPush({
              name: "zodiacMatch",
              params: {
                routerTransition: "forward",
                free_count: item.free_count
              }
            });
          }
        },
        GenderSwitch: {
          img: this.$remoteImg("icons/home/gender_switch.png"),
          text: this.$t("home_page.main_function_list.gender_switch"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "Gender_Switch"
            });

            _this4.resetResultByName("genderSwitch"); // 重置缓存值


            _this4.genderSwitch().catch(function (err) {});
          }
        },
        LoveCompatibility: {
          img: this.$remoteImg("icons/home/love_compatibility_home.png"),
          text: this.$t("home_page.main_function_list.love_compatibility"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "Love_Compatibility"
            });

            _this4.routerPush({
              name: "loveCompatibility",
              params: {
                routerTransition: "forward"
              }
            });
          }
        },
        palmistry: {
          img: this.$remoteImg("icons/home/daily_palmistry.png"),
          text: this.$t("home_page.main_function_list.palmistry"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "Palmistry"
            });

            _this4.resetResultByName("dailyPalm"); // 重置缓存值


            _this4.goToPlamistry();
          }
        },
        LoveConsultant: {
          img: this.$remoteImg("icons/home/love_consultant.png"),
          text: this.$t("home_page.main_function_list.love_consultant"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "Love_Consultant"
            });

            _this4.loveConsultant();
          }
        },
        WealthForecast: {
          img: this.$remoteImg("icons/home/wealth_forecast.png"),
          text: this.$t("home_page.main_function_list.wealth_forecast"),
          clickFunction: function clickFunction() {
            sendMapEvent("uia_card_click", {
              key: "Wealth_Forecast"
            });

            _this4.wealthForeCast().catch(function (err) {});
          }
        },
        palmPrintReading: {
          img: this.$remoteImg("icons/home/palm_print@3x.png"),
          text: this.$t("home_page.main_function_list.palm_print_reading"),
          clickFunction: function () {
            var _clickFunction = _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee4() {
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      sendMapEvent("uia_card_click", {
                        key: "Palm_Print"
                      });

                      _this4.routerPush({
                        name: "palmPrintReading",
                        params: {
                          routerTransition: "forward"
                        }
                      });

                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            function clickFunction() {
              return _clickFunction.apply(this, arguments);
            }

            return clickFunction;
          }()
        },
        faceReading: {
          img: this.$remoteImg("icons/face-reading/face_reading.png"),
          text: this.$t("home_page.main_function_list.face_reading"),
          clickFunction: function () {
            var _clickFunction2 = _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee5() {
              return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      sendMapEvent("uia_card_click", {
                        key: "Face_Read"
                      });

                      _this4.routerPush({
                        name: "faceReading",
                        params: {
                          routerTransition: "forward"
                        }
                      });

                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));

            function clickFunction() {
              return _clickFunction2.apply(this, arguments);
            }

            return clickFunction;
          }()
        },
        celebrities: {
          img: this.$remoteImg("icons/face-reading/celebs_like_me_new.png"),
          text: this.$t("home_page.main_function_list.elebrities"),
          clickFunction: function () {
            var _clickFunction3 = _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee6() {
              return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      sendMapEvent("uia_card_click", {
                        key: "celebrities"
                      });

                      _this4.getCelebries();

                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            function clickFunction() {
              return _clickFunction3.apply(this, arguments);
            }

            return clickFunction;
          }()
        }
      };
    }
  }, {
    key: "function_list",
    get: function get() {
      var _this5 = this;

      var list = this.mainFunctionList;
      var result_list = [];

      if (list) {
        list.forEach(function (v) {
          if (_this5.mapList[v.function] && !(v.group && v.group === "hot")) {
            result_list.push(_Object$assign(_this5.mapList[v.function], v));
          }
        });
      }

      return result_list;
    }
  }, {
    key: "hot_function_list",
    get: function get() {
      var _this6 = this;

      var list = this.mainFunctionList;
      var result_list = [];

      if (list) {
        list.forEach(function (v) {
          if (_this6.mapList[v.function] && v.group && v.group === "hot") {
            result_list.push(_Object$assign(_this6.mapList[v.function], v));
          }
        });
      }

      console.log("result_list", result_list);
      return result_list;
    }
  }, {
    key: "titleStyle",
    get: function get() {
      return {
        top: window.StatusBar.actualHeight + 44 + "px"
      };
    }
  }]);

  return Home;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], Home.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.AGEING_FORECAST)], Home.prototype, "ageingForecast", void 0);

tslib_1.__decorate([Action(types.GENDER_SWITCH)], Home.prototype, "genderSwitch", void 0);

tslib_1.__decorate([Action(types.ETHNICITY_SCANNER)], Home.prototype, "ethnicityScanner", void 0);

tslib_1.__decorate([Action(types.PERSONAL_FUTRUE)], Home.prototype, "personalFutrue", void 0);

tslib_1.__decorate([Getter(types.GETTER_HOROSCOPE)], Home.prototype, "horoScope", void 0);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], Home.prototype, "payByIap", void 0);

tslib_1.__decorate([Getter(types.GETTER_MAIN_FUNCTION_LIST)], Home.prototype, "mainFunctionList", void 0);

tslib_1.__decorate([Action(types.TAKE_PHOTO_EX)], Home.prototype, "takePhoto", void 0);

tslib_1.__decorate([Action(types.PALMISTRY_PHOTO)], Home.prototype, "palmistryPhoto", void 0);

tslib_1.__decorate([Action(types.FETCH_PALM_PRINT_DATA)], Home.prototype, "fetchPalmPrintData", void 0);

tslib_1.__decorate([Action(types.FETCH_FACE_READING_DATA)], Home.prototype, "fetchFaceRadingData", void 0);

tslib_1.__decorate([Action(types.PALMISTRY)], Home.prototype, "palmistry", void 0);

tslib_1.__decorate([Action(types.WEALTH_FORE_CAST)], Home.prototype, "wealthForeCast", void 0);

tslib_1.__decorate([Action(types.LOVE_COMSULTANT)], Home.prototype, "loveConsultant", void 0);

tslib_1.__decorate([Mutation(types.RESET_RESULT_BY_NAME)], Home.prototype, "resetResultByName", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_FUNCTION_LIST)], Home.prototype, "updateFunctionList", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_READING_LIST)], Home.prototype, "updateReadingList", void 0);

tslib_1.__decorate([Getter(types.GETTER_TEMP_RESULT_BY_NAME)], Home.prototype, "getTempResultByName", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], Home.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Action(types.GET_CELEBRITES_PHOTOS)], Home.prototype, "getCelebries", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_CARD_CLICK_TIMES)], Home.prototype, "updateCardClickTime", void 0);

tslib_1.__decorate([Getter(types.GETTER_CARD_CLICK_TIMES)], Home.prototype, "cardClickTime", void 0);

Home = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    RevealFate: RevealFate,
    FunctionTags: FunctionTags,
    VideoPlayer: VideoPlayer,
    swiper: swiper,
    swiperSlide: swiperSlide,
    HomeReadCraouser: HomeReadCraouser
  },
  name: "home"
})], Home);
export default Home;